import { combineReducers } from "redux";
import AppReducer from "./AppReducer";
import MeReducer from "./MeReducer";
import NotificationReducer from "./NotificationReducer";
import SubscribtionReducer from "./SubscribtionReducer";
import LayersReducer from "./LayersReducer";
import MapReducer from "./MapReducer";
import LeftPanelReducer from "./LeftPanelReducer";
import GeoJsonReducer from "./GeoJsonReducer";
import FormsReducer from "./FomsReducer";
import PrintReducer from "./PrintReducer";
import SearchReducer from "./SearchReducer";
import DashboardReducer from "./DashboardReducer";
import ShopCartReducer from "./ShopCartReducer";
import ShopReducer from "./ShopReducer";
import CommandReducer from "./CommandeReducer";
import StripeReducer from "./StripeReducer";
import FilterToolsReducer from "./FilterToolsReducer";
import filterReducer from "./filterReducer";

export default combineReducers({
   AppReducer,
   NotificationReducer,
   MeReducer,
   SubscribtionReducer,
   LayersReducer,
   MapReducer,
   LeftPanelReducer,
   GeoJsonReducer,
   FormsReducer,
   PrintReducer,
   SearchReducer,
   DashboardReducer,
   ShopCartReducer,
   ShopReducer,
   CommandReducer,
   StripeReducer,
   FilterToolsReducer,
   filter: filterReducer,
});
